<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>說起來，聽到臺灣文化協會，總算有點追溯賴和故事的感覺了。</npc>
              <npc :npc-id="0">為什麼？</npc>
              <npc :npc-id="1" right>之前說過嘛，我對賴和的印象就是抗議不公，說到臺灣文化協會，不也跟社運有關嗎？很符合賴和的形象。</npc>
              <npc :npc-id="0">嗯⋯⋯這話也不算錯，但賴和先生後來跟臺灣文化協會的關係不太好喔？</npc>
              <npc :npc-id="1" right>咦？為什麼？</npc>
              <npc :npc-id="0">其實也不算不好，但怎麼說呢，臺灣文化協會後來因為路線不同而分裂，左派更被日本政府肅清，賴和先生對左派運動感到幻滅，還表現在作品裡。</npc>
              <npc :npc-id="1" right>咦？有這樣的作品？</npc>
              <npc :npc-id="0">有啊！像賴和先生的〈赴會〉，紀錄主角在火車上聽見人們的對話，言談間就對左派運動不以為然，而主角——應該就是賴和先生的化身——聽到了則感到羞愧，因為他自己就是左派運動的參與者。</npc>
              <npc :npc-id="1" right>怎麼會這樣？難道賴和最後是否定左派的嗎？</npc>
              <npc :npc-id="0">不是那樣的。賴和先生只是有感於改變世界並非這麼容易，而且比起實踐，更多的知識分子只是唱高調；賴和先生也不是否定理想，而是不能實踐的理想，對普羅百姓是沒有意義的吧？</npc>
              <npc :npc-id="1" right>原來如此⋯⋯我還以為賴和是那種戰鬥型的小說家呢。</npc>
              <npc :npc-id="0">當然也有那部分，不過，那也只是賴和先生的一部分，別忘了，他在這裡被稱為『彰化媽祖』、『和仔仙』，除了小說家以外，他也是救人的醫生，當然也有一般人的煩惱跟沮喪；說到對社運失望，現在也一定有這樣的青年不是嗎？但那不是後悔或否定過去的自己。賴和先生也只是跟那些人一樣，並持續用自己的方式在努力而已。</npc>
              <npc :npc-id="1" right>我懂了。該怎麼說呢，真沒想到，雖然是追查怪盜，但我好像真的比起前更暸解賴和了耶？</npc>
              <npc :npc-id="0">這只是說明你作為文學偵探的助手有多怠惰吧？好了，這裡就是公會堂——彰化美術館了。</npc>

              <story-image :src="require(`@/assets/images/pics/第2章_2-1_公會堂.jpg`)" size="lg"></story-image>
              <!-- （圖片：公會堂） -->

              <npc :npc-id="1" right>喔！講臺居然保留下來了耶！</npc>
              <npc :npc-id="0">是啊，賴和先生曾擔任臺灣文化協會的講師，不知道他有沒有在這個講臺上演講過？雖然印象中沒有這樣的紀錄——好了，該找找怪盜留下的線索了。</npc>
              <npc :npc-id="1" right>啊！講臺上有張紙條！</npc>

              <story-image :src="require(`@/assets/images/pics/第2章_2-2_公會堂謎題圖.jpg`)"></story-image>
              <!-- （圖片：公會堂題目紙條） -->

              <npc :npc-id="0">開頭就寫『致呂善安君』，很明顯是給我的呢。</npc>
              <npc :npc-id="1" right>這什麼意思？林氏好？林錦鴻？這些人跟賴和有關嗎？</npc>
              <npc :npc-id="0">似乎沒有，林氏好是一位歌手，但她是臺南人啊？為什麼⋯⋯啊，我知道了，她跟彰化公會堂有關，曾經在這裡演唱。</npc>
              <npc :npc-id="1" right>那其他人呢？</npc>
              <npc :npc-id="0">不，這不重要。小蘇，你看下面的『彰化市公會堂歷史沿革』就知道了，重點不是人。這裡有常設展，介紹彰化公會堂的歷史，這題目八成跟常設展有關。</npc>
              <npc :npc-id="1" right>啊，我知道了，所以是去找跟這些人有關的展板，是嗎？</npc>
              <npc :npc-id="0">正是如此，答案恐怕是文字，而且是五個字吧？小蘇，開始行動吧！</npc>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="這裡有常設展，介紹彰化公會堂的歷史。答案應該是五個字喔！" morehint="大標題和小標題不用計算在內！">
              <p>
                林氏好：第八行15和16<br/>
                林錦鴻：第十行26<br/>
                李崇禮：第七行8<br/>
                彰化市公會堂歷史沿革：第十行10
              </p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage2_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第二章 - 2',
      isQuestion: true,
      stageId: 'lin',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
